/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ErrorMessage extends Component {
  render() {
    return (
      <div
        data-for={this.props.for}
        style={{
          display:
            this.props.manual || this.props.visible ? 'block' : 'none',
        }}
        className={`${this.props.className} ${
          this.props.visible ? 'error_desc' : ''
          }`}
      >
        {this.props.children}
      </div>
    );
  }
}

ErrorMessage.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  visible: PropTypes.bool,
  manual: PropTypes.bool,
  for: PropTypes.any,
};

ErrorMessage.defaultProps = {
  visible: false,
  manual: false,
  className: 'rv-error-message',
  for: '',
};



// WEBPACK FOOTER //
// ./app/components/Validation/ErrorMessage.js